import { render } from "./SelectProduct.vue?vue&type=template&id=233f284d"
import script from "./SelectProduct.vue?vue&type=script&lang=js"
export * from "./SelectProduct.vue?vue&type=script&lang=js"

import "./SelectProduct.vue?vue&type=style&index=0&id=233f284d&lang=scss"
script.render = render

export default script